import qs from 'qs';
import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function atividades(params) {
  const options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, {encode: false});
    }
  };

  return axios.get(`${url}/atividades`, options)
    .then(response => {
      return {
        atividades: jsona.deserialize(response.data),
        meta: response.data.meta
      };
    });
}

function prospects(params) {
  const options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, {encode: false});
    }
  };

  return axios.get(`${url}/prospects`, options)
    .then(response => {
      return {
        prospects: jsona.deserialize(response.data),
        meta: response.data.meta
      };
    });
}

export default {
  atividades,
  prospects
};

